import userApi from "@/api/userApi";
import Company from "./company";
import Contract from "./contract";
import { DATE_FORMAT } from "@/common/constant";
import moment from "moment";
import UserCompany from "@/model/userCompany";

export enum USER_TYPE {
  STAFF = 2,
  CUSTOMER = 3,
}

export enum USER_ROLE {
  ADMIN = 0,
  MANAGE = 1,
  WITNESS = 2,
  OWNER = 3,
}

export const USER_ROLE_NAME = {
  [USER_ROLE.ADMIN]: "システム管理者",
  [USER_ROLE.MANAGE]: "管理会社",
  [USER_ROLE.WITNESS]: "立会業者",
  [USER_ROLE.OWNER]: "オーナー",
}

export enum STATUS {
  WAIT = 0,
  JOIN = 1,
}

export const STATUS_NAME = {
  [STATUS.WAIT]: "wait",
  [STATUS.JOIN]: "join",
}

export enum LINK_TYPE {
  DIRECT = 1,
  COM_2_COM = 2,
  USER_2_USER = 3,
}

export interface IUser {
  id?: string;
  username: string;
  created?: string;
  email?: string;
  password?: string;
  company_id?: number;
  company?: Company;
  type: USER_TYPE;
  avatar_id: string;
  avatar: any;
  companies: any[];
  represent_company: Company;
  user_company: UserCompany;
  user_companies: UserCompany[];
  customer_contracts?: Contract[];
}

export class UserDTO implements IUser {
  id?: string;
  username = null;
  name = null;
  department_name = null;
  is_enabled? = false;
  created? = null;
  email? = null;
  password? = null;
  re_password? = null;
  company_id?: number;
  company?: Company;
  type: USER_TYPE;
  avatar_id: string;
  avatar: any;
  customer_contracts?: Contract[];
  companies: any[];
  represent_company: Company;
  user_company: UserCompany;
  user_companies: UserCompany[];
}

export default class User extends UserDTO {
  original = {};
  constructor(dto?: UserDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
      // dto.customer && (dto.customer = new Customer(dto.customer));
    } else {
      this.new();
    }
  }

  get statusName(): string {
    return this.is_enabled ? "on" : "off";
  }

  get userCompanies() {
    return this.user_companies.map((item) => {
      return new UserCompany(item);
    })
  }

  get cooperationStatusName(): string {
    return this.getCooperationStatusName(this.user_company.status);
  }

  public getCooperationStatusName(status) {
    return STATUS_NAME[status];
  }

  get isJoined() {
    return this.checkIsJoined(this.user_company.status);
  }

  get roleName() {
    return this.getRoleName(this.user_company.role_id);
  }

  get cooperationCount(): number {
    if (this.isCustomer) {
      return this.customer_contracts.length;
    }
    return this.user_companies.length;
  }

  get isRepresentCompany() {
    return !!this.represent_company && this.represent_company.id === this.user_company.affiliation_company_id;
  }

  get representCompanyId() {
    return this.represent_company ? this.represent_company.id : null;
  }

  get isCustomer() {
    return this.type == USER_TYPE.CUSTOMER
  }

  public getRoleName(roleId) {
    return USER_ROLE_NAME[roleId];
  }

  public checkIsJoined(status) {
    return status === STATUS.JOIN;
  }

  public formatDateJa(date): string {
    return date ? moment(date).format(DATE_FORMAT) : "";
  }

  public new() {
    Object.assign(this, {
      id: null,
      login_id: null,
      email: null,
      password: null,
      is_enabled: null,
      company_id: null,
      companies: [],
      represent_company: null,
      user_company: new UserCompany(),
      user_companies: [],
    });
  }

  public async updateMe() {
    const result = await userApi.updateMe(this);
    return result
  }
}

export class UserCustomer extends User {
  public delete() {
    // return new Promise((resovle, reject) => {
    //   userApi.deleteUserCustomer(this.id).then((response) => {
    //     if (response.data.message == "success") {
    //       resovle(response.data);
    //     } else {
    //       reject(response.data);
    //     }
    //   });
    // });
  }

  public save() {
    // const dataRequest = _.pick(this, [
    //   "login_id",
    //   "busyo_name",
    //   "department_name",
    //   "email",
    //   "password",
    //   "customer_code",
    // ]);
    // dataRequest.customer_code = this.customer.customer_code;
    // if (this.id) {
    //   return new Promise((resovle, reject) => {
    //     userApi.editUserCustomer(this.id, dataRequest).then((response) => {
    //       if (response.data.message == "success") {
    //         resovle(response.data);
    //       } else {
    //         reject(response.data);
    //       }
    //     });
    //   });
    // } else {
    //   dataRequest.name = this.customer.customer_name;
    //   return this.create(dataRequest);
    // }
  }

  public create(data) {
    console.log(data);
    // return new Promise((resovle, reject) => {
    //   userApi.addUserCustomer(data).then((response) => {
    //     if (response.data.message == "success") {
    //       resovle(response.data);
    //     } else {
    //       reject(response.data);
    //     }
    //   });
    // });
  }
}
